import { render, staticRenderFns } from "./the-sidebar.vue?vue&type=template&id=62381c48&scoped=true"
import script from "./the-sidebar.vue?vue&type=script&lang=js"
export * from "./the-sidebar.vue?vue&type=script&lang=js"
import style0 from "./the-sidebar.vue?vue&type=style&index=0&id=62381c48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62381c48",
  null
  
)

export default component.exports